// TODO: Add tick icon in library

import Typography from '@ixigo/iui/Typography';
import { TestId } from '../../enums/test';
import check3d from '../../images/check3d.svg';

type Props = {
    actorName: string;
};

function ConversationResolution({ actorName }: Props) {
    return (
        <div
            className='mx-20 my-5 p-10 text-green-500 text-center bg-green-50 border border-green-200 rounded-10'
            data-testid={TestId.RESOLUTION}
        >
            <Typography className='flex gap-0.5 justify-center items-center'>
                <img src={check3d} alt='resolved' />
                This conversation was marked as
            </Typography>
            <Typography fontWeight='bold'>resolved by {actorName}</Typography>
        </div>
    );
}

export default ConversationResolution;
